<template>
  <div class="pa-park-note-editor-quill-new">
    <div class="pa-quill-image-uploader">
      <form method="POST" enctype="application/x-www-form-urlencoded" class="pa-quill-form-file-hidden">
        <input :disabled="isDisabledUploader" @change="handleChangeImageUploaderFileField" type="file" accept="image/*" ref="imageFileInput" multiple />
      </form>
    </div>

    <form class="pa-editor-form" ref="editorForm">
      <div class="editor-form-head" ref="editorHead">
        <label for="pa-park-note-editor-title">タイトル</label>
        <input
         type="text"
         placeholder="タイトルを入力"
         class="pa-title"
         id="pa-park-note-editor-title"
         v-model="titleText"
         ref="titleInput"
        />
        <hr class="pa-separator" />
        <label for="pa-park-note-editor-quill">内容</label>
      </div>

      <div class="editor-form-editor" ref="editorField">
        <div class="quill-editor" id="pa-park-note-editor-quill" ref="quillEditor"></div>
      </div>

      <div class="editor-form-meta" :class="editorMetaClass" ref="editorMeta">
        <div class="controls">
          <div class="left-side">
            <div class="quill-toolbar" id="quill-toolbar" ref="quillToolbar">
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-underline"></button>
                <button class="ql-header" value="1"></button>
                <select class="ql-color">
                  <option v-for="color in inkColorList" :key="color" :value="color"></option>
                </select>
                <button class="ql-link"></button>
                <button class="ql-image"></button>
              </span>
            </div>
          </div>

          <div class="right-side">
            <PAInkCounterBanner
              class="pa-ink-counter-banner-simple"
              v-if="shouldShowInkCounter"
              :textCounting="inkCountingParams.textCounting"
              :storedInkCount="inkCountingParams.storedInkCount"
              :unitLabel="inkCountingParams.unitLabel"
              :displayStyle="inkCountingParams.displayStyle"
              :textCountingStartLimit="textCountingStartLimit"
              :popperArrowPosition="inkCountBannerPopperArrowPosition"
            />
          </div>
        </div>

        <div class="auto-save-control">
          <p>
            <span
            class="text"
            v-if="enableDraftFunction"
            >{{draftStatusText}}</span>
            <span
            class="text"
            v-if="!enableDraftFunction"
            >編纂時は下書き機能は使用不可で御座います。</span>
            <button
            v-if="hasDraftData"
            class="control-button"
            @click.prevent="handleClickDeleteDraft"
            >下書きを削除する</button>
            <button 
             class="control-button control-button-focus-title"
             @click.prevent="handleClickForcusTitle"
            >タイトルを入力</button>
          </p>
        </div>
      </div>
    </form>
    <PAParkNoteEditorLoading />
  </div>
</template>

<script>
import PAInkCounterBanner           from '@/components/Parts/PAInkCounterBanner/PAInkCounterBanner.vue'
import CharacterInkCountableMixins  from '@/mixins/CharacterInkCountableMixins.js'

import PAQuillLoaderMixin                   from '@/components/Parts/PAParkNoteEditorQuillNew/mixins/PAQuillLoaderMixin.js'
import PAQuillImageUploaderMixin            from '@/components/Parts/PAParkNoteEditorQuillNew/mixins/PAQuillImageUploaderMixin.js'
import PAParkNoteEditorToolBarControlMixin  from '@/components/Parts/PAParkNoteEditorQuillNew/mixins/PAParkNoteEditorToolBarControlMixin.js'

import PAParkNoteEditorLoading from '@/components/Parts/PAParkNoteEditorQuillNew/PAParkNoteEditorLoading/PAParkNoteEditorLoading.vue'

import { Base64 } from 'js-base64'

export default {
  props : {
    editorFieldHeight : {
      default : null
    },

    enableDraftFunction : {
      default: true
    },

    shouldShowInkCounter : {
      default: false
    },

    textCountingStartLimit : {
      default: null
    },

    draftParkNote : {
      default : null
    },

    defaultTitle : {
      default : ''
    },

    defaultDeltaString : {
      default : ''
    },
  },

  components : {
    PAInkCounterBanner,
    PAParkNoteEditorLoading
  },

  mixins : [
    PAQuillLoaderMixin,
    PAQuillImageUploaderMixin,
    PAParkNoteEditorToolBarControlMixin,
    CharacterInkCountableMixins,
  ],

  data(){
    return {
      titleText : '',
      
      inkColorList : [
        '#3E3A37',
        '#A87D0E',
        '#8A7361',
        '#78970F',
        '#129D78',
        '#12789D',
        '#9B1142'
      ],

      inkCountBannerPopperArrowPosition : 'top',

      draftStatusText : '自動保存：なし',
      hasDraftData    : false,
    };
  },

  watch : {
    editorFieldHeight(value){
      if(value === null) return;

      this.$refs.editorForm.style.height = value + 'px';

      this.$nextTick(() => {
        this.calcEditorHeight();
      });
    },

    draftParkNote : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data === null){
          this.hasDraftData = false;
          this.draftStatusText = '自動保存：なし';
        }else{
          this.hasDraftData = true;
          this.draftStatusText = '自動保存：'+this.$options.filters.mutateJPTimeOnly(data.updated_at);
        }
      },
      deep:true
    },

    titleText(value){
      this.$emit('onChangeTitle', value);
    },

    defaultTitle : {
      handler(value){
        if(this.titleText === ''){
          this.titleText = value;
        }

        if(value == null){
          this.titleText = '';
        }
      },
      immediate: true
    },

    defaultDeltaString : {
      handler(value){
        if(value === '') return;

        let loopCount = 0;

        const intervalId = setInterval(() => {
          loopCount++;

          if(this.isQuillMounted === true){
            clearInterval(intervalId);

            const textCounter = this.getTextCount();

            if((textCounter === 0) && value !== ''){
              const deltaData = JSON.parse(Base64.decode(value));
              this.quill.setContents(deltaData);
            }

            if(value === null){
              this.quill.setContents([{ insert: '\n' }]);
            }
          }

          if(loopCount > 100){
            clearInterval(intervalId);
          }
        }, 50);
      },
      immediate: true
    },
  },

  methods : {
    handleClickDeleteDraft(){
      this.$emit('onClickDeleteDraftData');
    },

    handleClickForcusTitle(){
      this.$refs.titleInput.focus();

      setTimeout(() => {
        this.toolbarPosition = 'default';
        this.setToolbarPositionDown();
      }, 100);
    },

    calcEditorHeight(){
      const editorHeight = this.getClientRectHeight(this.$refs['editorField']);

      this.$refs.editorField.querySelector('.ql-editor').style.height = editorHeight + 'px';
    }
  },

  created(){
    this.$parent.$parent.$on('beforeEnterContent', () => {
      this.initializeImageUpload();
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";
@import '~quill/dist/quill.snow.css';

.pa-park-note-editor-quill-new{
  position: relative;

  .pa-quill-image-uploader{
    .pa-quill-form-file-hidden{
      position: absolute;
      top:0;
      left:0;
      opacity: 0;
      width:0.1px;
      height:0.1px;
      overflow: hidden;
    }
  }

  .pa-note-editor-loading{
    .pa-wrapper > .pa-field{
      width:98%;
      margin:0 auto;
      border-radius: 8px;

      @include from($desktop) {
        width:632px;
      }
    }
  }

  form.pa-editor-form{
    display: block;
    box-sizing: border-box;
    position: relative;
    margin:0 auto;
    padding:0;

    display:flex;
    flex-grow: 1;
    flex-direction: column;
    width: 98%;

    border:4px solid #89620C;
    background-color:#C8A984;
    border-radius: 8px;
    color:#3e3a37;

    @include from($desktop) {
      width:632px;
    }

    .editor-form-head{
      label{
        display: none;
      }

      input{
        display: block;
        width: 100%;
        padding: .3rem .4rem;
        font-size: 1.2rem;
        line-height: 1.4;
        background-color: inherit;
        border: 0;
        font-family: mplus-1m-medium;
        letter-spacing: .5px;

        &::placeholder{
          color:#B79771;
        }

        &:focus{
          outline:none;
        }

        &.pa-title{
          box-sizing: border-box;
          margin-top:.2rem;
          color:#3e3a37;
          margin:0;
        }
      }

      hr.pa-separator{
        display:block;
        background-color:#D9C9AD;
        background-color:#C1A27C;
        margin:0 auto;
        width:98%;
        height:2.9px;
      }
    }

    .editor-form-editor{
      height:100%;
      overflow: hidden;
      
      div.quill-editor{
        &.ql-container{
          font-family: 'mplus-1m-medium';
          // font-size:14px;
          font-size:1rem;
          color:#3e3a37;

          &.ql-snow{
            border:0;
          }
        }

        .ql-editor.ql-blank::before{
          font-family: 'mplus-1m-medium';
          color:#B79771;
          font-style: normal;
          font-size:1.2rem;
          line-height: 1.4;
        }
      }

      .ql-snow{
        .ql-editor{
          -webkit-user-select:text;

          h1{
            margin:.2rem 0;
            font-size:1.5rem;
          }

          strong{
            color:inherit;
          }

          a{
            text-decoration: underline;
          }
        }

        .ql-tooltip{
          box-sizing: border-box;
          background-color: #C1A27C;
          border: 4px solid #B9966C;
          box-shadow: none;
          border-radius: 6px;
          color:#3e3a37;
          &::before{
            content: "URL:";
          }

          a.ql-action::after{
            content: '編集';
            color:#3e3a37;
            border-right: 1px solid #BD9D75;
          }

          a.ql-remove::before{
            content: '削除';
            color:#3e3a37;
          }

          input[type=text]{
            border:0;
            border-bottom:1px solid #B9976E;
          }
        }
      }
    }

    .editor-form-meta{
      flex-grow: 0;

      .controls{
        display: flex;
        background-color:rgba(200, 200, 200, .5);
        color:#868179;
        flex-direction: row;
        border-radius:0 0 4px 4px;
        user-select: none;

        .left-side{
          width:55%;
          display:flex;
          flex-direction: row;

          .quill-toolbar{
            &.ql-toolbar{
              &.ql-snow{
                border:0;
              }
            }
            .ql-formats{
              margin:0;
              svg{
                path{
                  fill:#5B5854 !important;
                }
              }
              .ql-active{
                svg{
                  path{
                    fill:#292826 !important;
                  }
                }
              }
            }
          }
        }

        .right-side{
          width:45%;
          text-align: right;
          display:flex;
          flex-direction: row-reverse;
          align-items: center;
          position: relative;

          .text-counter{
            margin-right:.5rem;
            font-size:1.1rem;
            line-height: 2.4;
          }
        }
      }

      .auto-save-control{
        width:100%;
        background-color:rgba(200, 200, 200, .5);
        color:#868179;
        user-select: none;
        padding:.2rem .5rem;
        font-size:.7rem;
        text-align: left;
        line-height: 1rem;
        
        span.text{
          margin-right:.5rem;
        }

        button.control-button{
          margin-right:.5rem;
          padding:.5px .3rem .5px;
          font-size: .65rem;
          border-radius: 6px;
          border:1px solid #5B5854;
          color:#5B5854;
          background-color: inherit;

          &-focus-title{
            display: none;
          }
        }

        .pa-ink-counter-banner{
          display: inline;
        }
      }

      &-hidden{
        display: none;
      }

      &-up-mobile-keyboard{
        @media screen and (max-width: $tablet) {
          position: fixed;
          width:100vw;
          top:0;
          left:0;

          .controls,.auto-save-control{
            background-color:rgba(200, 200, 200, .8);
            border-radius:0 0 0;
          }

          .auto-save-control{
            .pa-ink-counter-banner{
              display: block;
              // position: absolute;
            }
          }

          .controls{
            .right-side{
              .text-counter{
                font-size:.9rem;
                line-height: 1.8;
              }
            }

            #quill-toolbar{
              padding:2px;
              .ql-picker-options{
                top:100%;
                bottom:inherit;
              }
            }
          }

          .auto-save-control{
            font-size:.65rem;
            line-height: .9rem;
            position: relative;

            button.control-button{
              padding:.3px .2rem .3px;
              font-size: .6rem;
              margin-right:.2rem;

              &-focus-title{
                display: block;
                font-size:.8rem;
                position: absolute;
                bottom:.2rem;
                right: 1rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>